import { useEffect, useState } from 'react';

//PROPS
interface Props {
    size?: number,
    strokeWidth?: number,
    progress: number, // Valor final
    duration?: number, // segundos
    circleColor?: string,
    progressColor?: string,
    textColor?: string,
    fontSize?: number
}

export const ProgressCircle: React.FC<Props> = ({
    size = 40,
    strokeWidth = 4.5,
    progress = 0, // Valor final
    duration = 1, // segundos
    circleColor = '#eee',
    progressColor = '#007bff',
    textColor = '#333',
    fontSize = 9
}) => {

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    const [animatedProgress, setAnimatedProgress] = useState(0);

    useEffect(() => {

        const timeout = setTimeout(() => {
            setAnimatedProgress(progress);
        }, 1000);

        return () => clearTimeout(timeout);
    }, [progress]);


    let progresso_final = animatedProgress <= 100 ? animatedProgress : 100;
    let progresso_excedente = animatedProgress > 100 ? animatedProgress - 100 : 0;

    const offset = circumference - (progresso_final / 100) * circumference;
    const offset_excedente = circumference - (progresso_excedente / 100) * circumference;

    return (
        <svg width={size} height={size}>
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={circleColor}
                strokeWidth={strokeWidth}
                fill="none"
            />
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={progressColor}
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset}
                strokeLinecap="round"
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
                style={{
                    transition: `stroke-dashoffset ${duration}s ease`
                }}
            />
            <circle
                cx={size / 2}
                cy={size / 2}
                r={radius}
                stroke={progressColor==="#0958d9" ? "#38B8DB" : "#67F520"}
                strokeWidth={strokeWidth}
                fill="none"
                strokeDasharray={circumference}
                strokeDashoffset={offset_excedente}
                strokeLinecap="round"
                transform={`rotate(-90 ${size / 2} ${size / 2})`}
                style={{
                    transition: `stroke-dashoffset ${duration}s ease-out ${0.85}s`
                }}
            />
           
            <text
                x="50%"
                y="50%"
                textAnchor="middle"
                dy=".3em"
                fontSize={fontSize}
                fill={textColor}
                fontWeight={600}
                fontFamily='Poppins'
            >
                {`${Math.round(animatedProgress)}%`}
            </text>
        </svg>
    );
};

